import {
  string as stringType
} from '@thd-nucleus/data-sources';
import THDStorageUtils, { LOCAL_STORAGE, SESSION_STORAGE } from '@thd-olt-global/thd-storage-utils';
import {
  INVALID_PROJECT_TEXT_MESSAGE,
  EMPTY_PROJECT_NAME_MESSAGE,
  INVALID_NAME_LENGTH_MESSAGE,
  EMPTY_PROJECT_TYPE_MESSAGE,
  INVALID_TYPE_LENGTH_MESSAGE,
  INVALID_NOTE_LENGTH_MESSAGE,
  INVALID_ADDRESS_LENGTH_MESSAGE,
  EMPTY_GROUP_NAME_MESSAGE,
  INVALID_GROUP_LENGTH_MESSAGE,
  STATUS_SESSION_STORAGE_KEY,
  STATUS_LOCAL_STORAGE_CREATE_NEW_PROJECT_DRAWER_ASSISTANT_KEY,
  STATUS_LOCAL_STORAGE_HOW_TO_GET_STARTED_DRAWER_ASSISTANT_KEY,
  INVALID_JOB_SITE_LENGTH_MESSAGE,
  INVALID_DELIVERY_REQUIREMENTS_LENGTH_MESSAGE,
  INVALID_PHONE_NUMBER_LENGTH_MESSAGE,
  INVALID_PHONE_NUMBER_FORMAT_MESSAGE,
  INVALID_DELIVERY_CONTACT_NAME_LENGTH_MESSAGE,
} from './constants';

export const storeStatusChange = (statusValue) => {
  THDStorageUtils.set(SESSION_STORAGE, { key: STATUS_SESSION_STORAGE_KEY, value: statusValue });
};
export const storeStatusCreateNewProjectDrawerAssistant = (statusValue) => {
  THDStorageUtils.set(LOCAL_STORAGE, {
    key: STATUS_LOCAL_STORAGE_CREATE_NEW_PROJECT_DRAWER_ASSISTANT_KEY,
    value: statusValue
  });
};
export const storeStatusHowToGetStartedDrawerAssistant = (statusValue) => {
  THDStorageUtils.set(LOCAL_STORAGE, {
    key: STATUS_LOCAL_STORAGE_HOW_TO_GET_STARTED_DRAWER_ASSISTANT_KEY,
    value: statusValue
  });
};
export const checkStatusCreateNewProjectDrawerAssistant = () => {
  return THDStorageUtils.get(LOCAL_STORAGE, { key: STATUS_LOCAL_STORAGE_CREATE_NEW_PROJECT_DRAWER_ASSISTANT_KEY });
};
export const checkStatusHowToGetStartedDrawerAssistant = () => {
  return THDStorageUtils.get(LOCAL_STORAGE, { key: STATUS_LOCAL_STORAGE_HOW_TO_GET_STARTED_DRAWER_ASSISTANT_KEY });
};

export const PROJECT_SHAPE = {
  id: stringType(),
  name: stringType(),
  projectAccessType: stringType()
};

export const validateProjectName = (value) => {
  const validCharacters = /^(?=.{0,80}$)[ [\]{}|a-z|A-Z|!@#$%^&*()0-9-_+,.?"':;\\]+$/;
  const blank = !(value || '').replace(/\s/g, '');
  let isValid = validCharacters.test(value);
  const charLimit = value?.length > 80;
  let errorMessage = '';
  if (!isValid) {
    if (blank) {
      errorMessage = EMPTY_PROJECT_NAME_MESSAGE;
    } else if (charLimit) {
      errorMessage = INVALID_NAME_LENGTH_MESSAGE;
    } else {
      errorMessage = INVALID_PROJECT_TEXT_MESSAGE;
    }
  }
  return { isError: !isValid, errorMessage };
};

export const validateGroupName = (value) => {
  const validCharacters = /^(?=.{0,50}$)[ [\]{}|a-z|A-Z|!@#$%^&*()0-9-_+,.?"':;\\]+$/;
  const blank = !(value || '').replace(/\s/g, '');
  let isValid = validCharacters.test(value);
  const charLimit = value?.length > 50;
  let errorMessage = '';
  if (!isValid) {
    if (blank) {
      errorMessage = EMPTY_GROUP_NAME_MESSAGE;
    } else if (charLimit) {
      errorMessage = INVALID_GROUP_LENGTH_MESSAGE;
    } else {
      errorMessage = INVALID_PROJECT_TEXT_MESSAGE;
    }
  }
  return { isError: !isValid, errorMessage };
};

export const validatePropertyType = (value) => {
  const validCharacters = /^(?=.{0,40}$)[ [\]{}|a-z|A-Z|!@#$%^&*()0-9-_+,.?"':;\\]+$/;
  const blank = !(value || '').replace(/\s/g, '');
  let isValid = validCharacters.test(value);
  const charLimit = value?.length > 40;
  let errorMessage = '';
  if (!isValid) {
    if (blank) {
      errorMessage = EMPTY_PROJECT_TYPE_MESSAGE;
    } else if (charLimit) {
      errorMessage = INVALID_TYPE_LENGTH_MESSAGE;
    } else {
      errorMessage = INVALID_PROJECT_TEXT_MESSAGE;
    }
  }
  return { isError: !isValid, errorMessage };
};

export const validateProjectDescription = (value, key) => {
  let errorMessage = '';
  if (!value) return { isError: false, errorMessage };
  const validCharacters = /^(?=.{0,1000}$)[ [\]{}|a-z|A-Z|!@#$%^&*()0-9-_+,.?"':;\\]+$/;
  let isValid = validCharacters.test(value);
  const charLimit = value?.length > 1000;
  const charLimitJobSite = value?.length > 40;
  const charLimitDelReq = value?.length > 200;
  const charLimitContactName = value?.length > 40;
  if (!isValid) {
    if (charLimit && (key === 'undefined' || key === undefined || key === 200)) {
      errorMessage = INVALID_NOTE_LENGTH_MESSAGE;
    } else if (charLimitJobSite && key === 'Job Site Conditions') {
      errorMessage = INVALID_JOB_SITE_LENGTH_MESSAGE;
    } else if (charLimitDelReq && key === 'Delivery Requirements') {
      errorMessage = INVALID_DELIVERY_REQUIREMENTS_LENGTH_MESSAGE;
    } else if (charLimitContactName && key === 'Delivery Contact Name') {
      errorMessage = INVALID_DELIVERY_CONTACT_NAME_LENGTH_MESSAGE;
    } else {
      errorMessage = INVALID_PROJECT_TEXT_MESSAGE;
    }
  }
  return { isError: !isValid, errorMessage };
};

export const validateEstimatedStartDate = (value, endDate) => {
  if (endDate && (!value || new Date(value) >= new Date(endDate))) {
    return {
      isError: true,
      endDateErrorMessage: 'End date must be after start date',
    };
  }
  return { isError: false, endDateErrorMessage: '' };
};

export const validateEstimatedEndDate = (value, startDate) => {
  if ((new Date(value) <= new Date(startDate)) || !startDate) {
    return {
      isError: true,
      endDateErrorMessage: 'End date must be after start date'
    };
  }
  return { isError: false, endDateErrorMessage: '' };
};

export const validateTextField = (value, key) => {
  let errorMessage = '';
  if (!value) return { isError: false, errorMessage };
  const validCharacters = /^(?=.{0,60}$)[ [\]{}|a-z|A-Z|!@#$%^&*()0-9-_+,.?"':;\\]+$/;
  let isValid = validCharacters.test(value);
  const charLimit = value?.length > 60;
  const charLimitJobSite = value?.length > 40;
  const charLimitDelReq = value?.length > 200;
  const charLimitContactName = value?.length > 40;
  if (!isValid) {
    if (charLimit && (key === 'undefined' || key === undefined)) {
      errorMessage = INVALID_ADDRESS_LENGTH_MESSAGE;
    } else if (charLimitJobSite && key === 'Job Site Conditions') {
      errorMessage = INVALID_JOB_SITE_LENGTH_MESSAGE;
    } else if (charLimitDelReq && key === 'Delivery Requirements') {
      errorMessage = INVALID_DELIVERY_REQUIREMENTS_LENGTH_MESSAGE;
    } else if (charLimitContactName && key === 'Delivery Contact Name') {
      errorMessage = INVALID_DELIVERY_CONTACT_NAME_LENGTH_MESSAGE;
    } else {
      errorMessage = INVALID_PROJECT_TEXT_MESSAGE;
    }
  }
  return { isError: !isValid, errorMessage };
};

export const triggerAnalytics = (event, payload) => {
  LIFE_CYCLE_EVENT_BUS.trigger(event, payload);
};

export const cityAndStateValidation = (value) => {
  let errorMessage = '';
  if (!value) return { isError: false, errorMessage };
  const validCharacters = /^[a-zA-Z\s-]*$/;
  let isValid = validCharacters.test(value);
  if (!isValid) {
    errorMessage = 'Invalid text';
  }
  return { isError: !isValid, errorMessage };
};

export const getYesterday = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday;
};

export const formatDate = (date) => new Date(date).toISOString().split('T')[0];

export const isValidUrl = (str) => {
  const pattern = new RegExp(
    '^([a-zA-Z]+:\\/\\/)?' // protocol
      + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'
      + '((\\d{1,3}\\.){3}\\d{1,3}))'
      + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'
      + '(\\?[;&a-z\\d%_.~+=-]*)?'
      + '(\\#[-a-z\\d_]*)?$',
    'i'
  );
  return pattern.test(str);
};

export const validatePhoneNumber = (value) => {
  let errorMessage = '';
  if (!value) return { isError: false, errorMessage };

  // Check if the value contains any non-numeric characters (excluding common phone formatting)
  const hasInvalidChars = /[^0-9\s\-.()\\+]/.test(value);

  if (hasInvalidChars) {
    errorMessage = INVALID_PHONE_NUMBER_FORMAT_MESSAGE;
    return { isError: true, errorMessage };
  }

  // Remove all non-digit characters for validation
  const digitsOnly = value.replace(/\D/g, '');

  // Check if it's a valid US phone number (10 digits)
  const isValidLength = digitsOnly.length === 10;

  // Basic US phone number pattern (allows various formats)
  const phonePattern = /^[+]?[1]?[\s\-.]?[(]?([0-9]{3})[)]?[\s\-.]?([0-9]{3})[\s\-.]?([0-9]{4})$/;
  const isValidFormat = phonePattern.test(value);

  if (!isValidFormat || !isValidLength) {
    errorMessage = INVALID_PHONE_NUMBER_LENGTH_MESSAGE;
  }

  return { isError: !isValidFormat || !isValidLength, errorMessage };
};
